// extracted by mini-css-extract-plugin
export default {"container":"LoadingComponent_container__BBQmP","asciiArt":"LoadingComponent_asciiArt__5eKhw"};